import { useState, useEffect } from 'react';
import { Table, Tag, message } from 'antd';
import Card from '@/components/Card/Card';
import { CardItem } from '@/interface/card';
import { DeviceItem } from '@/interface/device';
import Https from '@/https';
import './Home.css';

export default function Home() {
  const [messageApi, messageContextHolder] = message.useMessage();
  const defaultCardList : CardItem[]= [
    {
      title: '设备总数',
      subTitle: '台',
      value: 0,
      icon: 'robot',
      desc: '较昨日新增 32 台设备',
    },
    {
      title: '离线设备数',
      subTitle: '台',
      value: 0,
      icon: 'offline',
      desc: '增加 1.0% 较昨日',
    },
    {
      title: '告警设备数',
      subTitle: '台',
      value: 0,
      icon: 'warn',
      desc: '减少 2.5% 较昨日',
    },
    {
      title: '今日任务完成率',
      subTitle: '%',
      value: 0.00,
      icon: 'task',
      desc: '增加 3.2% 较昨日',
    }
  ];
  const [cardList, setCardList] = useState<CardItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [deviceList, setDevieceList] = useState<DeviceItem[]>([]);
  const [deviceColumns] = useState([
    {
      title: '设备唯一码',
      dataIndex: 'sn',
      key: 'sn',
      width: 150
    },
    {
      title: '设备名称',
      dataIndex: 'name',
      key: 'name',
      width: 200
    },
    {
      title: '设备型号',
      dataIndex: 'modelName',
      key: 'modelName',
    },
    {
      title: '在线状态',
      dataIndex: 'isOnlineText',
      key: 'isOnlineText',
      render: (isOnlineText: string, record: any) => {
        return record.isOnline ? <Tag color="success">{isOnlineText}</Tag>: <Tag color="error">{isOnlineText}</Tag>;
      }
    },
    {
      title: '运营方式',
      dataIndex: 'isAllot',
      key: 'isAllot',
      render: (isAllot: number, record: any) => {
        return isAllot === 0 ? <Tag color="success">自营</Tag>: <Tag color="blue">{record.tenantName}</Tag>;
      }
    },
    {
      title: '点位地址',
      dataIndex: 'address',
      key: 'address',
      width: 200,
    },
    {
      title: '设备类型',
      dataIndex: 'typeName',
      key: 'typeName',
    },
    {
      title: '更新时间',
      dataIndex: 'modifyedTime',
      key: 'modifyedTime',
      width: 180
    },
  ])

  const getCardList = () => {
    Https.get({
      url: 'Api/device/V1/device/DeviceStatistics',
    }).then(res => {
      console.log(res)
      if(res.state === 1) {
        let data = defaultCardList;
        data[0].value = res.data.totalDeviceCount;
        data[1].value = res.data.offlineDeviceCount;
        data[2].value = res.data.alarmDeviceCount;
        data[3].value = res.data.completionRate;
        setCardList(data);
      }
    })
  }

  const getDeviceList = () => {
    Https.post({
      url: 'Api/device/V1/device/DeviceList',
      data: {
        pageSize: 10,
        pageIndex: 1
      }
    }).then(res => {
      if(res.state === 1) {
        setDevieceList(res.data.deviceList);
      } else {
        messageApi.error(res.data.errorMessage);
      }
    }).finally(() => {
      setLoading(false);
    })
  }

  useEffect(() => {
    getCardList();
    getDeviceList();
  }, [])
  return (
    <section className="Home">
      <section className="fun-title">数据总览</section>
      <section className="card-container">
        {
          cardList.map((item, index) => {
            return <Card key={index} {...item} />
          })
        }
      </section>
      <section className="fun-title">TOP设备</section>
      <section>
        <Table
          dataSource={deviceList}
          rowKey="deviceId"
          columns={deviceColumns}
          pagination={false}
          scroll={{x: 'max-content', y: 'calc(100vh - 470px)'}}
          loading={loading}
         />
      </section>
      { messageContextHolder }
    </section>
  )
}